import { Component, OnInit, Input, SimpleChanges, AfterViewInit, OnDestroy, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { VMediumDutiesFormTypeComboBoxModel } from './vmedium-duties-form-type-combo-box.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GetVMediumDutiesListService } from './api-services/get-vmedium-duties-list.service';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { VMediumDutiesForm } from './vmedium-duties-form.model';

/**
 * 共通部品　業態別媒体区分コンボボックスを制御するクラス
 *
 * @export VMediumDutiesFormTypeComboBoxComponent
 * @class VMediumDutiesFormTypeComboBoxComponent
 */
@Component({
  selector: 'app-vmedium-duties-form-type-combo-box',
  templateUrl: 'vmedium-duties-form-type-combo-box.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: VMediumDutiesFormTypeComboBoxComponent,
      multi: true
    },
    {
      provide: GetVMediumDutiesListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetVMediumDutiesListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]

    },
  ]
})
export class VMediumDutiesFormTypeComboBoxComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor {

  public selectedMediumType: string = <string>'';
  public selectedMediumName: string = <string>'';
  public selectedStopOrderCode: string = <string>'';
  public selectedProgressWorkNum: string = <string>'';
  public selectedProgressWorkNumName: string = <string>'';
  public selectedReceiptEOrderCode: string = <string>'';
  public selectedReceiptECatalogId: string = <string>'';
  public selectedMediumTypeClass: string = <string>'';
  public selectedDutiesFormDiv: string = <string>'';
  public model: VMediumDutiesFormTypeComboBoxModel = new VMediumDutiesFormTypeComboBoxModel();
  public selectedIndex: number = <number>-1;

  @ViewChild('comboBox', { static: true }) public comboBox: ElementRef;

  @Input() public subid: string = null;
  @Input() blank: boolean = <boolean>true;                                      // 空白フラグ
  @Input() allMediumType: boolean = <boolean>false;                             // 全媒体表示フラグ
  @Input() initAutoLoad: boolean = <boolean>true;                               // オートロードフラグ
  @Input() orderCode: string = <string>'';                                      // 検索条件「受注コード」を設定する(voの値)
  @Input() orderCodeMediumeTypeClear: string = <string>'';                      // 検索条件「受注コード」を設定する(媒体タイプをクリアする)
  @Input() public tabindex: number = <number>0;
  @Input() forcedEnabledMode: string = null;

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number = <number>20;
  @Input() required: boolean = <boolean>false;
  @Input() initFocusItem: any = null;                                           // ロード完了後フォーカスを移動させるid
  @Input() afterFocus: any = null;                                              // ロード完了後フォーカスを移動させるid
  @Input() visible: boolean = <boolean>true;                                    // 表示・非表示フラグ

  /**
   * Creates an instance of VMediumDutiesFormTypeComboBoxComponent.
   * @param {ElementRef} elementRef
   * @param {PlessDialogService} dialogService
   * @param {GetVMediumDutiesListService} getVMediumDutiesListService
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  constructor(
    public elementRef: ElementRef,
    private getVMediumDutiesListService: GetVMediumDutiesListService,
  ) { }

  // ValueAccessor
  public disabled: boolean;
  public onChange(_: any) { }
  public onTouched() { }
  public writeValue(text: string): void {
    if (text !== this.selectedMediumType) {
      this.selectedMediumType = text;
      this.setMediumType(text);
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * 初期処理
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public ngOnInit(): void {
    // コンボボックスインスタンス設定
    this.model.component = this;
    this.comboBox.nativeElement.setAttribute('id', this.subid + '_sub');
    this.comboBox.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  ngAfterViewInit(): void {
    if (this.model.initAutoLoad) {
      // データ取得
      this.getData();
    }
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'blank':
          //  先頭空白表示フラグ
          this.model.blank = changes.blank.currentValue;
          break;
        case 'allMediumType':
          // 全媒体表示表示フラグ
          this.model.allMediumType = changes.allMediumType.currentValue;
          break;
        case 'initAutoLoad':
          // 初期データ自動取得フラグ
          this.model.initAutoLoad = changes.initAutoLoad.currentValue;
          break;
        case 'orderCode':
          // 検索条件「受注コード」を設定するフラグ
          this.orderCode = changes.orderCode.currentValue;
          break;
        case 'orderCodeMediumeTypeClear':
          // 検索条件「受注コード」を設定する(媒体タイプ)をクリアするフラグ
          this.orderCode = changes.orderCodeMediumeTypeClear.currentValue;
          this.model.orderCode = changes.orderCodeMediumeTypeClear.currentValue;
          this.model.setMediumType = '';                                        // 初期選択の初期化
          if (!PlessViewUtilsSub.isEmpty(this.orderCode)) {
            // オーダーコードがあればリロード
            this.getData();
          }
          break;
      }
    });
  }

  /**
   * コンポーネント終了時
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  ngOnDestroy(): void {
    // コンボボックス情報初期化
    this.clear();
  }

  /**
   * コンボボックス情報初期化
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public clear(): void {
    // コンボボックス情報初期化
    this.selectedMediumType = <string>'';
    this.selectedMediumName = <string>'';
    this.selectedStopOrderCode = <string>'';
    this.selectedProgressWorkNum = <string>'';
    this.selectedProgressWorkNumName = <string>'';
    this.selectedReceiptEOrderCode = <string>'';
    this.selectedReceiptECatalogId = <string>'';
    this.selectedMediumTypeClass = <string>'';
    this.selectedDutiesFormDiv = <string>'';
    this.selectedIndex = <number>-1;
    this.model = new VMediumDutiesFormTypeComboBoxModel();
    this.model.component = this;
    this.model.blank = this.blank;
    this.model.allMediumType = this.allMediumType;
  }

  /**
   * コンボボックスの選択媒体Nameを切り替える
   *
   * @param {string} mediumType 媒体区分
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  setMediumType(mediumType: string): void {
    this.model.setMediumType = mediumType;

    // ロード完了の場合
    if (this.model.completeUpdateFlg) {
      this.updateSelectedMediumType();
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public updateSelectedMediumType(): void {
    const mediumList: VMediumDutiesForm[] = this.model.mediumList;

    for (let i = Number(0); i < mediumList.length; i++) {
      if (mediumList[i].MediumType === this.model.setMediumType) {
        this.selectedIndex = i;
        break;
      }
    }

    if (this.afterFocus != null) {
      if (this.afterFocus instanceof HTMLElement) {
        this.afterFocus.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.afterFocus.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }
    }

    if (this.initFocusItem != null) {
      if (this.initFocusItem instanceof HTMLElement) {
        // 参照先の型がElementならそのままフォーカスをあてる
        this.initFocusItem.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.initFocusItem.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }

      this.initFocusItem = null;
    }

    // バインドフィールドを更新
    this.updateBindedField(null);
  }

  /**
   * フェーズ番号名称取得
   *
   * @private
   * @param {string} progressWorkNum
   * @param {string} progressWorkName
   * @returns {string}
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  private getProgressWorkNumName(progressWorkNum: string, progressWorkName: string): string {
    if (PlessViewUtilsSub.isEmpty(<string>progressWorkNum) || PlessViewUtilsSub.isEmpty(<string>progressWorkName)) {
      return PlessViewUtilsSub.nullToBlank(progressWorkNum) + PlessViewUtilsSub.nullToBlank(progressWorkName);
    } else {
      return PlessViewUtilsSub.nullToBlank(progressWorkNum) + ':' + PlessViewUtilsSub.nullToBlank(progressWorkName);
    }

  }

  /**
   * コンボボックスの内容を再度ロードする
   *
   * @param {string} [orderCode=''] 受注コード
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public reload(orderCode = ''): void {
    this.orderCode = orderCode;
    this.getData();
  }

  /**
   * バインドフィールド初期化
   *
   * @param {*} e
   * @returns {void}
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public updateBindedField(e: any): void {
    if (e != null) {
      this.selectedIndex = e.target.selectedIndex;
    }
    if (this.selectedIndex === -1) {
      this.selectedMediumType = <string>'';
      this.selectedMediumName = <string>'';
      this.selectedStopOrderCode = <string>'';
      this.selectedProgressWorkNum = <string>'';
      this.selectedProgressWorkNumName = <string>'';
      this.selectedReceiptEOrderCode = <string>'';
      this.selectedReceiptECatalogId = <string>'';
      this.selectedMediumTypeClass = <string>'';
      this.selectedDutiesFormDiv = <string>'';
      return;
    }

    this.selectedMediumType = this.model.mediumList[this.selectedIndex].MediumType;
    this.selectedMediumName = this.model.mediumList[this.selectedIndex].MediumName;
    this.selectedStopOrderCode = this.model.mediumList[this.selectedIndex].StopOrderCode;
    this.selectedProgressWorkNum = this.model.mediumList[this.selectedIndex].ProgressWorkNum;
    this.selectedProgressWorkNumName = this.getProgressWorkNumName(
      this.model.mediumList[this.selectedIndex].ProgressWorkNum,
      this.model.mediumList[this.selectedIndex].ProgressWorkName);
    this.selectedReceiptEOrderCode = this.model.mediumList[this.selectedIndex].ReceiptEOrderCode;
    this.selectedReceiptECatalogId = this.model.mediumList[this.selectedIndex].ReceiptECatalogId;
    this.selectedMediumTypeClass = this.model.mediumList[this.selectedIndex].MediumTypeClass;
    this.selectedDutiesFormDiv = this.model.mediumList[this.selectedIndex].DutiesFormDiv;

    // 同じ意味合いのafterFocusがあればinitFocusItemに入れる
    if (this.afterFocus != null) {
      this.initFocusItem = this.afterFocus;
    }

    if (this.initFocusItem != null) {
      let queryedElement;
      if (this.initFocusItem instanceof HTMLElement) {
        queryedElement = this.initFocusItem.querySelector('textarea, input, select');
      } else {
        queryedElement = this.initFocusItem.elementRef.nativeElement.querySelector('textarea, input, select');
      }
      (queryedElement ? <HTMLElement>queryedElement : this.initFocusItem).focus();
    }
  }

  /**
   * データ取得
   *
   * @memberof VMediumDutiesFormTypeComboBoxComponent
   */
  public getData(): void {
    this.getVMediumDutiesListService.execute(this.model, this.orderCode);
  }

}
